import axiosInstance from '../axiosInterceptor/axiosInstance'

const regenerateApiKey = async (orgId) => {
  const url = `v1/orgs/${orgId}/api-key/regenerate`
  const response = await axiosInstance.post(url)
  return response?.data
}

export default regenerateApiKey
